// extracted by mini-css-extract-plugin
export default {"headingWrapper":"HeadingComponent_headingWrapper__WcCwb","headingImage":"HeadingComponent_headingImage__N2MDi","arrowBack":"HeadingComponent_arrowBack__0gE9S"};